import {
  configDev,
  configLocalhost,
  configLocalhostDev,
  configSandbox,
  configStaging,
} from './environmentsOther';
import { configProduction } from './environmentsProd';

import type { Config } from './configType';

// Envs Golden Configuration
// https://docs.google.com/spreadsheets/d/1hMnb4vHxfV0SM4QWotHPEYluohNrASP5uBBRioYIDLo/edit#gid=1029190598

export {
  configProduction,
  configDev,
  configLocalhost,
  configLocalhostDev,
  configSandbox,
  configStaging,
};

// Default configuration pointing to production API servers
const hostname = window?.location?.host || '';

/** Required for geo-whitelisted wallets to be able unlock */
export const isDisabledGeoblock =
  window?.location?.search === '?DISABLE_GEOBLOCK';

export const configByHost: Config | undefined = hostname.includes('widgets-')
  ? undefined
  : hostname === 'perps.katana.network' ||
    hostname === 'perps-preview-prod.katana.network' ||
    hostname === 'perps-feature-1-prod.katana.network' ||
    hostname === 'perps-feature-2-prod.katana.network' ||
    hostname === 'perps-feature-3-prod.katana.network' ||
    hostname === 'perps-local-prod.katana.network:5173' ||
    hostname === 'perps-local-prod.katana.network'
  ? configProduction
  : hostname.includes('perps-sandbox.katana-perps-dev.com') ||
    hostname.includes('perps-sandbox.katana.network') ||
    hostname.includes('perps-preview-sandbox.katana.network') ||
    hostname.includes('perps-feature-1-sandbox.katana.network') ||
    hostname.includes('perps-feature-2-sandbox.katana.network') ||
    hostname.includes('perps-feature-3-sandbox.katana.network') ||
    hostname.includes('perps-local-sandbox.katana.network')
  ? configSandbox
  : hostname.includes('perps-main-dev.katana-perps-dev.com') ||
    hostname.includes('perps-preview-dev.katana-perps-dev.com') ||
    hostname.includes('perps-feature-1-dev.katana-perps-dev.com') ||
    hostname.includes('perps-feature-2-dev.katana-perps-dev.com') ||
    hostname.includes('perps-feature-3-dev.katana-perps-dev.com') ||
    hostname.includes('perps-local-dev.katana-perps-dev.com')
  ? configDev
  : hostname.includes('perps-main-staging.katana-perps-dev.com') ||
    hostname.includes('perps-preview-staging.katana-perps-dev.com') ||
    hostname.includes('perps-feature-1-staging.katana-perps-dev.com') ||
    hostname.includes('perps-feature-2-staging.katana-perps-dev.com') ||
    hostname.includes('perps-feature-3-staging.katana-perps-dev.com') ||
    hostname.includes('perps-local-staging.katana-perps-dev.com')
  ? configStaging
  : hostname.includes('perps-local-localhost.katana-perps-dev.com') ||
    hostname.includes(':5173') // Dev server (localhost)
  ? configLocalhost
  : hostname.includes('perps-local-private.katana-perps-dev.com') // Private Chain;
  ? configLocalhostDev
  : undefined;

export const configForUnitTests = configDev;
